import { Form } from 'antd';

export const useFormInstance = Form.useFormInstance;
